import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import DatePicker from "react-datepicker";
import { Button, Paper } from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
// import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { BeatLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { getCustomerRegData } from '../../../Redux/action/Admin/CustomerAction';
import { adminMainUrl } from "../../../Config.jsx";

const CompanyDetails = ({ customer_id }) => {

  let [disable, setDisable] = useState(false);
  let [showLoader, setShowLoader] = useState(true);
  const [filePreview, setFilePreview] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(customer_id)
    if (customer_id) {
      dispatch(getCustomerRegData(customer_id))
    }
  }, []);

  let {
    loadingCustomerRegDataApi,
    CustomerRegDataError,
    CustomerRegData,
  } = useSelector(state => state?.CustomerReducer);



  let initialValues = {
    licenseImage: [],
    customerType: "",
    name: "",
    yearOfEstablishment: "",
    CIN: "",
    GST: "",
    TAN: "",
    PAN: "",
    nameOfAuthority: "",
    permanentRegaddress: "",
    principalBusinessAddress: "",
    typeOfBusiness: "",
    descriptionOfBusiness: "",
    websiteLink: "",
    directorProprietorName: "",
    directorProprietorNumber: "",
    directorProprietorEmail: "",
    salesPersonName: "",
    salesPersonNumber: "",
    salesPersonEmail: "",
    accountsPersonName: "",
    accountsPersonNumber: "",
    accountsPersonEmail: "",
    financeControllerName: "",
    financeControllerNumber: "",
    financeControllerEmail: "",
    msmeIndustryType: "",
    msmeRegNo: "",
    previourAgentAddress: "",
    reasonOfLeavingPreviousAgent: "",
    currentlyWorkingWith: "",
  }

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({


    }),
    onSubmit: (values, { resetForm }) => {

    }
  });


  useEffect(() => {
    if (CustomerRegData) {
      formik.setValues({
        customerType: CustomerRegData?.customerType ?? "",
        name: CustomerRegData.name ?? "",
        yearOfEstablishment: CustomerRegData.yearOfEstablishment ?? "",
        CIN: CustomerRegData.CIN ?? "",
        GST: CustomerRegData.GST ?? "",
        TAN: CustomerRegData.TAN ?? "",
        PAN: CustomerRegData.PAN ?? "",
        nameOfAuthority: CustomerRegData.nameOfAuthority ?? "",
        permanentRegaddress: CustomerRegData.permanentRegaddress ?? "",
        principalBusinessAddress: CustomerRegData.principalBusinessAddress ?? "",
        typeOfBusiness: CustomerRegData.typeOfBusiness ?? "",
        descriptionOfBusiness: CustomerRegData.descriptionOfBusiness ?? "",
        websiteLink: CustomerRegData?.websiteLink ?? "",
        directorProprietorName: CustomerRegData.directorProprietorName ?? "",
        directorProprietorNumber: CustomerRegData.directorProprietorNumber ?? "",
        directorProprietorEmail: CustomerRegData.directorProprietorEmail ?? "",
        salesPersonName: CustomerRegData.salesPersonName ?? "",
        salesPersonNumber: CustomerRegData.salesPersonNumber ?? "",
        salesPersonEmail: CustomerRegData.salesPersonEmail ?? "",
        accountsPersonName: CustomerRegData.accountsPersonName ?? "",
        accountsPersonNumber: CustomerRegData.accountsPersonNumber ?? "",
        accountsPersonEmail: CustomerRegData.accountsPersonEmail ?? "",
        financeControllerName: CustomerRegData.financeControllerName ?? "",
        financeControllerNumber: CustomerRegData.financeControllerNumber ?? "",
        financeControllerEmail: CustomerRegData.financeControllerEmail ?? "",
        msmeIndustryType: CustomerRegData.msmeIndustryType ?? "",
        msmeRegNo: CustomerRegData.msmeRegNo ?? "",
        previourAgentAddress: CustomerRegData.previourAgentAddress ?? "",
        reasonOfLeavingPreviousAgent: CustomerRegData.reasonOfLeavingPreviousAgent ?? "",
        currentlyWorkingWith: CustomerRegData.currentlyWorkingWith ?? "",
      })
    }
  }, [CustomerRegData])

  useEffect(() => {
    if (CustomerRegData && CustomerRegData?.CustomerLicenseCertificates?.length > 0) {
      const existingImages = CustomerRegData?.CustomerLicenseCertificates?.map((certificate) => `${adminMainUrl}/${certificate.image}`);
      setFilePreview(existingImages); // Set existing images for preview
    }
  }, [CustomerRegData]);

  // Handling new file uploads
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files); // Get selected files
    const newFilePreviews = files.map((file) => URL.createObjectURL(file)); // Create previews for new files

    // Update Formik values with new files only
    formik.setFieldValue('licenseImage', files);

    // Set new file previews, discarding previous ones
    setFilePreview(newFilePreviews);
  };

  return (
    <>
      {/* <Toaster /> */}
      {

        <div className="customer_main_detail_form section1" id="section1">
          <form onSubmit={formik.handleSubmit} className='p-4'>
            <div className='form-heading-bg'>
              <span>Company Details</span>

            </div>
            <FocusError formik={formik} />
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Customer Type
                  </label>
                  <input
                    type="text"
                    className="form-select form-select-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='customerType'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.customerType}
                  />

                  <div className="help-block with-errors">
                    {formik.touched.customerType && formik.errors.customerType ? (
                      <div className='text-danger small'>{formik.errors.customerType}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Name of Private or Public Limited Company / Individual / Proprietary firm /
                    Partnership firm
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='name'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                    maxLength={30}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.name && formik.errors.name ? (
                      <div className='text-danger small'>{formik.errors.name}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Year of establishment (DD/MM/YYYY)
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='yearOfEstablishment'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.yearOfEstablishment}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.yearOfEstablishment && formik.errors.yearOfEstablishment ? (
                      <div className='text-danger small'>{formik.errors.yearOfEstablishment}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    CIN No.
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='CIN'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.CIN}
                    maxLength={10}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.CIN && formik.errors.CIN ? (
                      <div className='text-danger small'>{formik.errors.CIN}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    GST Regn. No.
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='GST'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.GST}
                    maxLength={10}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.GST && formik.errors.GST ? (
                      <div className='text-danger small'>{formik.errors.GST}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    TAN No. (if not please mention N/A)
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='TAN'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.TAN}
                    maxLength={10}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.TAN && formik.errors.TAN ? (
                      <div className='text-danger small'>{formik.errors.TAN}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    PAN No.
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='PAN'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.PAN}
                    maxLength={10}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.PAN && formik.errors.PAN ? (
                      <div className='text-danger small'>{formik.errors.PAN}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Name of the Directors / Partners
                    / Proprietor etc.
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='nameOfAuthority'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.nameOfAuthority}
                    maxLength={30}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.nameOfAuthority && formik.errors.nameOfAuthority ? (
                      <div className='text-danger small'>{formik.errors.nameOfAuthority}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Permanent or Registered address
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='permanentRegaddress'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.permanentRegaddress}
                    maxLength={200}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.permanentRegaddress && formik.errors.permanentRegaddress ? (
                      <div className='text-danger small'>{formik.errors.permanentRegaddress}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Principal Business address
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='principalBusinessAddress'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.principalBusinessAddress}
                    maxLength={200}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.principalBusinessAddress && formik.errors.principalBusinessAddress ? (
                      <div className='text-danger small'>{formik.errors.principalBusinessAddress}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="col-md-12 row">
                <div className="mb-3">
                  <div className='col-md-12'>
                    <label
                      htmlFor="basicpill-firstname-input"
                      className="form-label"
                    >
                      Brief Description of Business of your
                      entity
                    </label>
                  </div>
                  <div className='col-md-12'>
                    <textarea
                      type="text"
                      className="form-control" aria-label="With textarea"
                      id="basicpill-firstname-input"
                      placeholder="Enter here"
                      name='descriptionOfBusiness'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.descriptionOfBusiness}
                      cols={50}

                    ></textarea>
                  </div>
                  <div className="help-block with-errors">
                    {formik.touched.descriptionOfBusiness && formik.errors.descriptionOfBusiness ? (
                      <div className='text-danger small'>{formik.errors.descriptionOfBusiness}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Director/ Proprietor
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='directorProprietorName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.directorProprietorName}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.directorProprietorName && formik.errors.directorProprietorName ? (
                      <div className='text-danger small'>{formik.errors.directorProprietorName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter contact number here"
                    name='directorProprietorNumber'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.directorProprietorNumber}
                    maxLength={10}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.directorProprietorNumber && formik.errors.directorProprietorNumber ? (
                      <div className='text-danger small'>{formik.errors.directorProprietorNumber}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter email here"
                    name='directorProprietorEmail'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.directorProprietorEmail}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.directorProprietorEmail && formik.errors.directorProprietorEmail ? (
                      <div className='text-danger small'>{formik.errors.directorProprietorEmail}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Sales
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='salesPersonName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.salesPersonName}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.salesPersonName && formik.errors.salesPersonName ? (
                      <div className='text-danger small'>{formik.errors.salesPersonName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter contact number here"
                    name='salesPersonNumber'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.salesPersonNumber}
                    maxLength={10}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.salesPersonNumber && formik.errors.salesPersonNumber ? (
                      <div className='text-danger small'>{formik.errors.salesPersonNumber}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter email here"
                    name='salesPersonEmail'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.salesPersonEmail}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.salesPersonEmail && formik.errors.salesPersonEmail ? (
                      <div className='text-danger small'>{formik.errors.salesPersonEmail}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Accounts
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='accountsPersonName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.accountsPersonName}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.accountsPersonName && formik.errors.accountsPersonName ? (
                      <div className='text-danger small'>{formik.errors.accountsPersonName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter contact number here"
                    name='accountsPersonNumber'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.accountsPersonNumber}
                    maxLength={10}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.accountsPersonNumber && formik.errors.accountsPersonNumber ? (
                      <div className='text-danger small'>{formik.errors.accountsPersonNumber}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter email here"
                    name='accountsPersonEmail'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.accountsPersonEmail}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.accountsPersonEmail && formik.errors.accountsPersonEmail ? (
                      <div className='text-danger small'>{formik.errors.accountsPersonEmail}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Finance Controller
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='financeControllerName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.financeControllerName}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.financeControllerName && formik.errors.financeControllerName ? (
                      <div className='text-danger small'>{formik.errors.financeControllerName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter contact number here"
                    name='financeControllerNumber'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.financeControllerNumber}
                    maxLength={10}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.financeControllerNumber && formik.errors.financeControllerNumber ? (
                      <div className='text-danger small'>{formik.errors.financeControllerNumber}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter email here"
                    name='financeControllerEmail'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.financeControllerEmail}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.financeControllerEmail && formik.errors.financeControllerEmail ? (
                      <div className='text-danger small'>{formik.errors.financeControllerEmail}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    MSME Industry Type
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <select
                    className="form-select form-select-sm mb-3"
                    aria-label=".form-select-lg example"
                    name='msmeIndustryType'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.msmeIndustryType}
                  >
                    <option value="">
                      Select Industry Type
                    </option>
                    <option >Micro</option>
                    <option>Small</option>
                    <option >Medium</option>
                  </select>
                  <div className="help-block with-errors">
                    {formik.touched.msmeIndustryType && formik.errors.msmeIndustryType ? (
                      <div className='text-danger small'>{formik.errors.msmeIndustryType}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter registration number here"
                    name='msmeRegNo'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.msmeRegNo}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.msmeRegNo && formik.errors.msmeRegNo ? (
                      <div className='text-danger small'>{formik.errors.msmeRegNo}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Website of the business entity
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='websiteLink'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.websiteLink}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.websiteLink && formik.errors.websiteLink ? (
                      <div className='text-danger small'>{formik.errors.websiteLink}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Previous Agent’s Address
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='previourAgentAddress'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.previourAgentAddress}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.previourAgentAddress && formik.errors.previourAgentAddress ? (
                      <div className='text-danger small'>{formik.errors.previourAgentAddress}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Reason for leaving them
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='reasonOfLeavingPreviousAgent'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.reasonOfLeavingPreviousAgent}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.reasonOfLeavingPreviousAgent && formik.errors.reasonOfLeavingPreviousAgent ? (
                      <div className='text-danger small'>{formik.errors.reasonOfLeavingPreviousAgent}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Currently Working With
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='currentlyWorkingWith'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.currentlyWorkingWith}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.currentlyWorkingWith && formik.errors.currentlyWorkingWith ? (
                      <div className='text-danger small'>{formik.errors.currentlyWorkingWith}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="basicpill-firstname-input" className="form-label">
                    Licenses and Certificates
                  </label>
                  <div className="custom-file-container">

                    <label className="custom-file-container__custom-file">
                      <i className="fa-solid fa-upload"></i> Upload Files
                      <input
                        type="file"
                        className="custom-file-container__custom-file__custom-file-input d-none"
                        multiple
                        accept="image/*" // Ensure only image files are selected
                        onChange={(e) => {
                          handleFileChange(e);
                        }}
                        onBlur={formik.handleBlur}
                      />
                      <span className="custom-file-container__custom-file__custom-file-control"></span>
                    </label>
                  </div>
                  <div className="help-block with-errors">
                    {formik.touched.licenseImage && formik.errors.licenseImage ? (
                      <div className="text-danger small">{formik.errors.licenseImage}</div>
                    ) : null}
                  </div>

                  {/* Image Preview Section */}
                  <div className="image-preview">
                    {filePreview.length > 0 && filePreview.map((imageUrl, index) => (
                      <img
                        key={index}
                        src={imageUrl}
                        alt={`License ${index}`}
                        className="img-thumbnail"
                        style={{ width: "100px", height: "100px", margin: "5px" }}
                      />
                    ))}
                  </div>
                </div>
              </div>

            </div>

          </form>
        </div>
      }

    </>

  )
}

export default CompanyDetails